import ConceptBase from '../concept_base';

class FlavorSequential extends ConceptBase {
  constructor(projectData, priceData, size) {
    super(projectData, priceData, size);
  }
}

export default FlavorSequential;
